import { query } from '../utilities';

export const accountPromote = () => {
    return query('/account/promote/', {
        config: {
            method: 'post'
        }
    });
};
